export const MsgEnums = {
  SOMETHING_WENT_WRONG: 'Sorry! something went wrong',
  TRY_AGAIN_LATER: 'Please try again later',
  TRY_AGAIN: 'Please try again',
  FILL_DETAILS: 'Please fill all details',
  SERVER_ISSUE: 'There is an issue with server',
};
